import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { Middleware } from 'redux';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';
import rootReducer, { rootSaga } from './features';

export default (() => {
  const middleware: Middleware[] = [];

  // drop thunk https://redux-toolkit.js.org/api/getDefaultMiddleware#included-default-middleware
  const [, ...rest] = getDefaultMiddleware();

  middleware.push(...rest);

  const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
  middleware.push(sagaMiddleware);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { createLogger } = require(`redux-logger`);
    middleware.push(createLogger());
  }

  const store = configureStore({
    reducer: rootReducer,
    middleware,
    devTools: process.env.NODE_ENV !== 'production'
  });

  sagaMiddleware.run(rootSaga);

  return store;
})();
